import { useState } from 'react'
import { ProductionDistance } from '../../../../../../types/OrganizationUnit'
import { Concept } from '../../../../../../types/Survey/Analysis/Concept'
import UnitSquareMeterComparison from './UnitSquareMeterComparison/UnitSquareMeterComparison'
import Modal from '../../../../../UI/Modal/Modal'
import props from '../../../../../../redux/props'
import { useSelector } from 'react-redux'
import Button from '../../../../../UI/Button/Button'
import Anwesenheit from './Anwesenheit/Anwesenheit'
import Desksharing from './Desksharing/Desksharing'
import Mitarbeiter from './Mitarbeiter/Mitarbeiter'

type Props = {
  concept: Concept
  productionDistance?: ProductionDistance
  floorUUID?: string
}

enum DiagramType {
  UNIT_SQUARE_METER_COMPARISON = 'UNIT_SQUARE_METER_COMPARISON',
  ANWESENHEIT_COMPARISON = 'ANWESENHEIT_COMPARISON',
  DESKSHARING_COMPARISON = 'DESKSHARING_COMPARISON',
  MITARBEITER_COMPARISON = 'MITARBEITER_COMPARISON',
}

const Diagrams: React.FC<Props> = ({ concept, productionDistance, floorUUID }) => {
  const [diagramType, setDiagramType] = useState<DiagramType>()
  const t = useSelector((s) => s[props.TRANSLATION])

  const nameTypeMapping = {
    [DiagramType.UNIT_SQUARE_METER_COMPARISON]: t.survey.analysis.concept.unitComparison.name,
    [DiagramType.ANWESENHEIT_COMPARISON]: t.survey.analysis.concept.anwesenheitComparison.name,
    [DiagramType.DESKSHARING_COMPARISON]: t.survey.analysis.concept.desksharingComparison.name,
    [DiagramType.MITARBEITER_COMPARISON]: t.survey.analysis.concept.mitarbeiterComparison.name,
  }

  const close = () => setDiagramType(null)

  return (
    <div>
      <div className="border-b border-blue font-bold">{t.survey.analysis.concept.comparison.headline}</div>
      <div className="flex gap-3 py-3">
        {Object.keys(DiagramType).map((type) => (
          <Button key={type} text={nameTypeMapping[type]} onClick={() => setDiagramType(type as DiagramType)} />
        ))}
      </div>
      <Modal xLarge noForm show={!!diagramType} onClose={close} title={nameTypeMapping[diagramType]}>
        <div className="flex flex-col gap-3">
          {diagramType === DiagramType.UNIT_SQUARE_METER_COMPARISON && (
            <UnitSquareMeterComparison concept={concept} productionDistance={productionDistance} floorUUID={floorUUID} />
          )}
          {diagramType === DiagramType.ANWESENHEIT_COMPARISON && (
            <Anwesenheit concept={concept} productionDistance={productionDistance} floorUUID={floorUUID} />
          )}
          {diagramType === DiagramType.DESKSHARING_COMPARISON && (
            <Desksharing concept={concept} productionDistance={productionDistance} floorUUID={floorUUID} />
          )}
          {diagramType === DiagramType.MITARBEITER_COMPARISON && (
            <Mitarbeiter concept={concept} productionDistance={productionDistance} floorUUID={floorUUID} />
          )}
        </div>
      </Modal>
    </div>
  )
}

export default Diagrams
